import { motion } from 'framer-motion';
import { LegacyRef, useState } from 'react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { FaFire } from 'react-icons/fa';
import { FaTrashCan } from 'react-icons/fa6';
import { RiEditFill } from 'react-icons/ri';
import { useServiceContext } from '../../contexts/ServiceProvider';
import useFeatureBasedPermissions from '../../hooks/useFeatureBasedPermissions';
import useUserClickObserver from '../../hooks/useUserClickObserver';
import { Service } from '../../types/services';
import ActionButton from '../CommonComps/Buttons/ActionButton';

const ServiceUpdateAction = ({ service }: { service: Service }) => {
  // integration of react hooks here
  const [showMenu, setShowMenu] = useState<boolean>(false);

  // integration of context hooks here
  const {
    setService,
    setShowUpdateModal,
    setShowDeleteModal,
    setShowAddToPopularModal,
  } = useServiceContext();

  // integration of custom hooks here
  const selectRef = useUserClickObserver(setShowMenu);
  const { featureBasedPermissions } = useFeatureBasedPermissions('service');

  // handler function to show modal on button click declared here
  const showModalHandler = (modalName: 'update' | 'delete' | 'popular') => {
    switch (modalName) {
      case 'update':
        setShowUpdateModal(true);
        setService(
          //   typeof rowIndex !== 'undefined' ? { service, rowIndex } :
          service
        );
        break;

      case 'delete':
        setShowDeleteModal(true);
        setService(
          //   typeof rowIndex !== 'undefined' ? { service, rowIndex } : service
          service
        );
        break;

      case 'popular':
        setShowAddToPopularModal(true);
        setService(service);
        break;

      default:
        break;
    }

    setShowMenu(false);
  };

  // rendering service update action component here
  return (
    <div ref={selectRef as LegacyRef<HTMLDivElement>} className='relative'>
      <div className='flex items-center justify-center'>
        <button
          onClick={() => setShowMenu((state) => !state)}
          className='hover:opacity-40 active:scale-90 duration-300'
        >
          <BsThreeDotsVertical className='size-6' />
        </button>
      </div>

      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={
          showMenu
            ? { height: 'fit-content', opacity: 1 }
            : { height: 0, opacity: 0 }
        }
        className='absolute bottom-1/2 right-0 bg-base-white shadow-academia-sm rounded-lg overflow-hidden'
      >
        <div className='max-h-[100px] overflow-y-auto academia-scrollbar'>
          <ActionButton
            title={
              !featureBasedPermissions?.includes('UPDATE')
                ? 'You do not have permissions!'
                : undefined
            }
            onClick={() => showModalHandler('update')}
            colorClass='text-base-cyan'
            isDisabled={!featureBasedPermissions?.includes('UPDATE')}
          >
            <RiEditFill />
            <span>Update Service</span>
          </ActionButton>

          <ActionButton
            title={
              !featureBasedPermissions?.includes('DELETE')
                ? 'You do not have permissions!'
                : undefined
            }
            onClick={() => showModalHandler('delete')}
            colorClass='text-base-red'
            isDisabled={!featureBasedPermissions?.includes('DELETE')}
          >
            <FaTrashCan />
            <span>Delete Service</span>
          </ActionButton>

          <ActionButton
            title={
              !featureBasedPermissions?.includes('UPDATE')
                ? 'You do not have permissions!'
                : undefined
            }
            onClick={() => showModalHandler('popular')}
            colorClass={
              !service.is_most_popular ? 'text-base-orange' : 'text-base-red'
            }
            isDisabled={!featureBasedPermissions?.includes('UPDATE')}
          >
            <FaFire />
            <span>
              {!service.is_most_popular
                ? 'Add To Popular'
                : 'Remove From Popular'}
            </span>
          </ActionButton>
        </div>
      </motion.div>
    </div>
  );
};

export default ServiceUpdateAction;
